import { Tag } from "@chakra-ui/react";
import { StatusManutencaoEnum } from "core/features/manutencao/typings";
import moment from "moment";

interface TagStatusManutencaoProps {
  color: string;
  status: string;
  bg?: string;
}

export default function TagStatusManutencao({
  color,
  status,
  bg = "white",
}: TagStatusManutencaoProps) {
  return (
    <Tag
      alignSelf="end"
      bg={bg}
      borderRadius={14}
      border={`solid 1px`}
      color={color}
      fontWeight={400}
      pt={1}
      pb={1}
      pr={5}
      pl={5}
    >
      {status}
    </Tag>
  );
}

export function TagsStatusManutencao({
  statusId,
  data,
}: {
  statusId: StatusManutencaoEnum;
  data: string;
}) {
  return statusId === StatusManutencaoEnum.Concluida ? (
    <TagStatusManutencao color="green" status="Concluída" />
  ) : statusId === StatusManutencaoEnum.Pendente &&
    moment(data).isBefore(moment(), "day") ? (
    <TagStatusManutencao color="red" status="Atrasada" />
  ) : statusId === StatusManutencaoEnum.Pendente ? (
    <TagStatusManutencao color="orange" status="Pendente" />
  ) : (
    <TagStatusManutencao color="red" status="Não realizada" />
  );
}
